import { createReducer } from '@reduxjs/toolkit';

import {
  loadPaymentOrderItemStart,
  loadPaymentOrderItemSuccess,
  loadPaymentOrderListSuccess,
  loadPaymentOrderStart,
  resetPaymentOrderItem,
} from './actions';
import { IPaymentOrderReducer } from './types';

const initialState: IPaymentOrderReducer = {
  list: {
    isLoading: false,
    isLoaded: false,
    data: {},
  },
  item: {
    isLoading: false,
    isLoaded: false,
    data: {},
  },
};

const paymentOrdersReducer = createReducer(initialState, (builder) => {
  builder
    .addCase(loadPaymentOrderStart, (state) => ({
      ...state,
      list: {
        ...state.list,
        isLoading: true,
      },
    }))
    .addCase(loadPaymentOrderListSuccess, (state, action) => ({
      ...state,
      list: {
        ...state.list,
        isLoading: false,
        isLoaded: true,
        data: action.payload,
      },
    }))
    .addCase(loadPaymentOrderItemStart, (state) => ({
      ...state,
      item: {
        ...state.item,
        isLoading: true,
      },
    }))
    .addCase(loadPaymentOrderItemSuccess, (state, action) => ({
      ...state,
      item: {
        ...state.item,
        isLoading: false,
        isLoaded: true,
        data: action.payload,
      },
    }))
    .addCase(resetPaymentOrderItem, (state) => ({
      ...state,
      item: {
        isLoading: false,
        isLoaded: false,
        data: {},
      },
    }));
});

export default paymentOrdersReducer;
